<section class="product-category bg-gray-product-category" [ngClass]="key ? 'product-search' : ''">
    <!-- <board-popup></board-popup> -->
    <div class="container">
        <div class="main-heading row contain">
            <div class="col">
                <ng-container *ngIf="!key">
                    <div class="paths">
                        <ul class="row ai-center">
                            <li class="col-auto home">
                                <span>Shopping</span>
                            </li>
                            <li class="col-auto">
                                <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                                    <path opacity="0.7" d="M1 9L5 5L1 0.999999" stroke="#2A2E46" />
                                </svg>
                            </li>
                            <li class="col-auto current">
                                <span *ngIf="cate != 'wish'">{{ parentMainHeading }}</span>
                                <span *ngIf="cate == 'wish'">{{ labelwish }}</span>
                            </li>
                        </ul>
                    </div>
                </ng-container>

                <ng-container *ngIf="key">
                    <div style="line-height: 1.2em; padding-right: 10px;">
                    <span>"{{ key }}"</span> {{ 'shopping.home.lbl.001' | translate }} {{ total }}
                    {{ 'shopping.home.lbl.002' | translate }}
                    </div>
                </ng-container>
            </div>
            <select-dropdown *ngIf="cate != 'wish'" id='sort-category' class="product-sort dropdown-select col-auto row" [options]="sortOptions"
                [selected]="sortSelected" (changeSelectedValue)="hanldeOnChangeSortSelectedValue($event)">
            </select-dropdown>
        </div>
    </div>
    <div class="pdList" *ngIf="cate != 'wish'">
        <router-outlet></router-outlet>
    </div>
    <ng-container *ngIf="cate == 'wish'">
      <app-wish-list-pdt></app-wish-list-pdt>
    </ng-container>
</section>


<!-- <div class="container main-container" [ngClass]="isLogined ? 'not-logged' : ''">
    <section class="product-category" [ngClass]="key ? 'product-search' : ''">
        <div class="main-heading row">
            <div class="col">
                <ng-container *ngIf="!key">
                    <div class="paths">
                        <ul class="row ai-center">
                            <li class="col-auto home">
                                <span>Home</span>
                            </li>
                            <li class="col-auto">
                                <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                                    <path opacity="0.7" d="M1 9L5 5L1 0.999999" stroke="#2A2E46" />
                                </svg>
                            </li>
                            <li class="col-auto current">
                                <span>{{ parentMainHeading }}</span>
                            </li>
                        </ul>
                    </div>
                </ng-container>

                <ng-container *ngIf="key">
                    <span>"{{ key }}"</span> {{ 'shopping.home.lbl.001' | translate }} {{ total }}
                    {{ 'shopping.home.lbl.002' | translate }}
                </ng-container>
            </div>



            <select-dropdown id='sort-category' class="dropdown-select col-auto row" [options]="sortOptions"
                [selected]="sortSelected" (changeSelectedValue)="hanldeOnChangeSortSelectedValue($event)">
            </select-dropdown>



        </div>
        <div>
            <router-outlet></router-outlet>
        </div>

    </section>
</div> -->

<section class="popups-container">
    <product-popup [show]="showProductPopup" [esc]="esc" [backHistory]="backHistory"
        (clickClosePopup)="handleOnClickToggleProductPopup($event);">
    </product-popup>
</section>
